<template>
  <div class="upload__button">
    <slot>
      <v-btn depressed outlined :loading="loading">
        {{ btnTitle }}
        <v-icon v-if="btnIcon.length > 0">{{ btnIcon }}</v-icon>
        <template v-slot:loader>
          <v-progress-circular
            indeterminate
            size="24"
            color="black"
            class="mx-2"
          ></v-progress-circular>
          <span v-if="progress < 100">{{ btnTitleLoading }}</span>
          <span v-if="progress < 100">{{ progress }}%</span>
          <span v-if="progress == 100">{{ btnTitleProcessing }}</span>
        </template>
      </v-btn>
    </slot>
    <input
      type="file"
      :multiple="multiple"
      name="up_vue_file"
      :disabled="loading"
      @change="selectFiles($event)"
    />
  </div>
</template>
<script>
import POST from "@/fm/http/post";
export default {
  props: {
    btnTitle: {
      type: String,
      default: ""
    },
    btnTitleLoading: {
      type: String,
      default: "Загрузка..."
    },
    btnTitleProcessing: {
      type: String,
      default: "Обработка..."
    },
    btnIcon: {
      type: String,
      default: ""
    },
    workDir: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      progress: 0,
      loading: false
    };
  },
  computed: {},
  methods: {
    selectFiles(event) {
      // files selected?
      if (event.target.files.length > 0) {
        // create new form data
        const data = new FormData();
        data.append("disk", "public");
        data.append("path", this.workDir);
        data.append("overwrite", true);
        // add file or files
        for (let i = 0; i < event.target.files.length; i += 1) {
          data.append("files[]", event.target.files[i]);
        }

        // axios config - progress bar
        const config = {
          onUploadProgress: progressEvent => {
            this.progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          }
        };

        // upload files
        this.loading = true;
        return POST.upload(data, config)
          .then(response => {
            this.loading = false;
            this.progress = 0;

            // if files uploaded successfully
            if (response.data.result.status === "success") {
              this.$emit("upload-success", response.data.result.uploaded);
            } else {
              this.$emit(
                "upload-error",
                "invalid response: ".JSON.stringify(response.data)
              );
            }
          })
          .catch(error => {
            this.loading = false;
            this.progress = 0;
            this.$emit("upload-error", error);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.upload__button {
  position: relative;
  overflow: hidden;

  input[type="file"] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }
}
</style>
